import { render } from "./vehicle-specs.vue?vue&type=template&id=5bbb1c6e&scoped=true"
import script from "./vehicle-specs.vue?vue&type=script&lang=js"
export * from "./vehicle-specs.vue?vue&type=script&lang=js"

import "./vehicle-specs.vue?vue&type=style&index=0&id=5bbb1c6e&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbb1c6e"]])

export default __exports__